import { useTheme } from 'styled-components'
import ReactSelect from 'react-select'

// Shared style configuration for all react-select instances
export const getSelectStyles = (theme) => ({
  control: (provided) => ({
    ...provided,
    backgroundColor: `${theme.inputBackground} !important`,
    borderColor: theme.borderColor,
    color: theme.input,
    minHeight: 'calc(2.25rem + 2px)',
    height: 'calc(2.25rem + 2px)',
    borderRadius: '.25rem',
    fontSize: '1rem',
    opacity: 1,
    marginBottom: theme.margin,
    '&:hover': {
      borderColor: theme.borderColor
    }
  }),
  valueContainer: (provided) => ({
    ...provided,
    height: 'calc(2.25rem)',
    padding: '0 .75rem',
    backgroundColor: 'transparent'
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: `${theme.inputBackground} !important`,
    border: `1px solid ${theme.borderColor}`,
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
    zIndex: 9999,
    opacity: 1
  }),
  menuList: (provided) => ({
    ...provided,
    backgroundColor: `${theme.inputBackground} !important`,
    padding: 0,
    opacity: 1
  }),
  menuPortal: (provided) => ({
    ...provided,
    zIndex: 9999
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? `${theme.primary} !important`
      : state.isFocused
        ? `${theme.secondaryBackground} !important`
        : `${theme.inputBackground} !important`,
    color: state.isSelected ? theme.primaryContrast : theme.input,
    cursor: 'pointer',
    padding: '8px 12px',
    opacity: 1,
    '&:active': {
      backgroundColor: `${theme.primary} !important`
    }
  }),
  singleValue: (provided) => ({
    ...provided,
    color: theme.input,
    opacity: 1
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: theme.secondaryBackground,
    opacity: 1
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: theme.input
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: theme.input,
    ':hover': {
      backgroundColor: theme.primary,
      color: theme.primaryContrast
    }
  }),
  input: (provided) => ({
    ...provided,
    color: theme.input,
    margin: 0,
    padding: 0
  }),
  placeholder: (provided) => ({
    ...provided,
    color: theme.input,
    opacity: 0.6
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: theme.input,
    padding: '4px',
    ':hover': {
      color: theme.input
    }
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    backgroundColor: theme.borderColor
  }),
  clearIndicator: (provided) => ({
    ...provided,
    color: theme.input,
    padding: '4px',
    ':hover': {
      color: theme.input
    }
  })
})

const Select = ({ options, value, onChange, placeholder, isMulti, isClearable, isDisabled, ...props }) => {
  const theme = useTheme()
  const selectStyles = getSelectStyles(theme)

  return (
    <ReactSelect
      styles={selectStyles}
      options={options}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      isMulti={isMulti}
      isClearable={isClearable}
      isDisabled={isDisabled}
      menuPortalTarget={document.body}
      {...props}
    />
  )
}

export default Select
